"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.create = create;
exports.update = update;
exports.updateOrder = updateOrder;
exports.updateView = updateView;
exports.remove = remove;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

var endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/split_inbox/all");
    }
  },
  create: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/split_inbox");
    }
  },
  update: {
    method: 'PUT',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/settings/split_inbox/").concat(id);
    }
  },
  updateOrder: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/split_inbox/orders");
    }
  },
  updateView: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/split_inbox/view");
    }
  },
  "delete": {
    method: 'DELETE',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/settings/split_inbox/").concat(id);
    }
  }
};

/**
 * Returns a list of config for split inbox
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SplitInboxListResponse>}
 */
function list(_x) {
  return _list.apply(this, arguments);
}

function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, options, _endpoints$list, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}

/**
 * Create a split inbox
 *
 * @public
 * @param {number} idx - Order index of the split inbox
 * @param {name} name - Name for it
 * @param {SplitInboxQuery} query - Search criteria
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SplitInboxCreateResponse>}
 */
function create(_x2, _x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, _ref3) {
    var idx, name, query, auth, options, _endpoints$create, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            idx = _ref2.idx, name = _ref2.name, query = _ref2.query;
            auth = _ref3.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              idx: idx,
              name: name,
              query: query
            }))(_utils.defaultOptionals);
            _endpoints$create = endpoints.create, method = _endpoints$create.method, url = _endpoints$create.url;
            _context2.next = 6;
            return (0, _requests.request)(url(), method, options);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}

/**
 * Update a split with sepecified config
 *
 * @public
 * @param {string} id - Unique ID for the split inbox
 * @param {number} idx - Order index of it
 * @param {string} name - Name for it
 * @param {SplitInboxQuery} query - Search criteria
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<SplitInboxUpdateResponse>}
 */
function update(_x4, _x5, _x6) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id, _ref4, _ref5) {
    var idx, name, query, auth, options, _endpoints$update, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            idx = _ref4.idx, name = _ref4.name, query = _ref4.query;
            auth = _ref5.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              idx: idx,
              name: name,
              query: query
            }))(_utils.defaultOptionals);
            _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
            _context3.next = 6;
            return (0, _requests.request)(url(id), method, options);

          case 6:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _update.apply(this, arguments);
}

/**
 * Update the order for split inboxes
 *
 * @public
 * @param {Array< id: string, idx: number>} orders - Orders to update
 * @param {Auth} auth - User  validated authentication
 * @returns {Promise<SplitInboxOrderUpdateReponse>}
 */
function updateOrder(_x7, _x8) {
  return _updateOrder.apply(this, arguments);
}

function _updateOrder() {
  _updateOrder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(orders, _ref6) {
    var auth, options, _endpoints$updateOrde, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref6.auth;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              orders: orders
            }))(_utils.defaultOptionals);
            _endpoints$updateOrde = endpoints.updateOrder, method = _endpoints$updateOrde.method, url = _endpoints$updateOrde.url;
            _context4.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _updateOrder.apply(this, arguments);
}

function updateView(_x9, _x10) {
  return _updateView.apply(this, arguments);
}

function _updateView() {
  _updateView = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(payload, _ref7) {
    var auth, id, view, options, _endpoints$updateView, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref7.auth;
            id = payload.id, view = payload.view;
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              id: id,
              view: view
            }))(_utils.defaultOptionals);
            _endpoints$updateView = endpoints.updateView, method = _endpoints$updateView.method, url = _endpoints$updateView.url;
            _context5.next = 6;
            return (0, _requests.request)(url(), method, options);

          case 6:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateView.apply(this, arguments);
}

function remove(_x11, _x12) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, _ref8) {
    var auth, options, _endpoints$delete, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref8.auth;
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
            _context6.next = 5;
            return (0, _requests.request)(url(id), method, options);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _remove.apply(this, arguments);
}
//# sourceMappingURL=split-inboxes.js.map